const baseURL = 'https://ventas.box504.com/';

export default baseURL;
